import { render, staticRenderFns } from "./useCase.vue?vue&type=template&id=5feddc6c&scoped=true&"
import script from "./useCase.vue?vue&type=script&lang=js&"
export * from "./useCase.vue?vue&type=script&lang=js&"
import style0 from "./useCase.vue?vue&type=style&index=0&id=5feddc6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feddc6c",
  null
  
)

export default component.exports